import { render, staticRenderFns } from "./AddPlacementComponent.vue?vue&type=template&id=62f58ecf&"
import script from "./AddPlacementComponent.vue?vue&type=script&lang=js&"
export * from "./AddPlacementComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports